import { PaperReceiptMode } from 'src/common/enumerations/paper-receipt-mode';
import { DigitalReceiptOptions } from 'src/common/interfaces/states/TenderingState';
import { ReceiptOptionsActionHandler } from '../business-logic/receipt-options-action-handler';

const digitalButton = (resolveHandler): ReceiptOptionsActionButton => ({
  id: 'receipt-dialog-digital',
  text: 'Digital',
  handleClick: () => ReceiptOptionsActionHandler.onAcceptDigital(resolveHandler),
});

const printButton = (resolveHandler): ReceiptOptionsActionButton => ({
  id: 'receipt-dialog-print',
  text: 'Print',
  handleClick: () => ReceiptOptionsActionHandler.onAcceptPrint(resolveHandler),
});

const bothButton = (resolveHandler): ReceiptOptionsActionButton => ({
  id: 'receipt-dialog-both',
  text: 'Both',
  handleClick: () => ReceiptOptionsActionHandler.onAcceptBoth(resolveHandler),
});

export const generateActionButtons = (
  resolveHandler,
  digitalReceiptOptions: DigitalReceiptOptions,
): ReceiptOptionsActionButton[] => {
  const buttons: ReceiptOptionsActionButton[] = [];

  if (digitalReceiptOptions.emailRequested || digitalReceiptOptions.phoneRequested) {
    buttons.push(digitalButton(resolveHandler));
  }

  if (digitalReceiptOptions.paperReceiptMode !== PaperReceiptMode.Never) {
    buttons.push(printButton(resolveHandler));
  }

  if (
    (digitalReceiptOptions.emailRequested || digitalReceiptOptions.phoneRequested) &&
    digitalReceiptOptions.paperReceiptMode !== PaperReceiptMode.Never
  ) {
    buttons.push(bothButton(resolveHandler));
  }

  return buttons;
};

interface ReceiptOptionsActionButton {
  id: string;
  text: string;
  handleClick(): void;
}
